import { ReportData, ReportTemplate } from "../../Definitions/valueTypes";

export const ArchivedReportData: ReportData[] = [
  {
    reportId: 1,
    name: "B",
    dataLevel: "animal_number",
    filterParameter: [//quickEntry -- IS 
        [
          {key:"milestone_id", /*OR*/ value:[{id: 1, label: "Insemination"}, {id: 2, label: "Farrowing"}, {id: 3, label: "Weaning"}]}, 
          //and
          {key:"animalGroupId", /*OR*/ value:[{id: 2, label: "2"}, {id: 3, label: "3"}]},
        ],
        //join
        // [
        //   {key:"condition", /*OR*/ value:[1,2]}, 
        //   //and
        //   // {key:"location", /*OR*/ value:[3,4]}
        // ],
   ],
    dataParameter: [
      "animalGroupId"
    ],
    startDate: 1736331492000,
    endDate: 1746703096000
  },
  {
    reportId: 3,
    name: "A",
    dataLevel: "animalGroupId",
    filterParameter: [
        [
          {key:"milestone_id", value:[{id: 1, label: "Insemination"}]}, 
          {key:"animalGroupId", value:[{id: 2, label: "2"}, {id: 3, label: "3"}]},
        ],
   ],
    dataParameter: [
      "animalGroupId"
    ],
    startDate: 1736331492000,
    endDate: 1746703096000
  },
  {
    reportId: 2,
    name: "C",
    dataLevel: "animalGroupId",
    filterParameter: [
        [
          {key:"milestone_id", value:[{id: 1, label: "Insemination"}, {id: 2, label: "Farrowing"}, {id: 3, label: "Moved to Farrowing"}, {id: 4, label: "Weaning"}]}, 
          {key:"animalGroupId", value:[{id: 2, label: "To"}, {id: 3, label: "Tre"}]},
        ],
   ],
    dataParameter: [
      "animalGroupId"
    ],
    startDate: 1736331492000,
    endDate: 1746703096000
  },
  {
    reportId: 12,
    name: "BA",
    dataLevel: "animal_number",
    filterParameter: [
        [
          {key:"milestone_id", value:[{id: 1, label: "Insemination"}, {id: 2, label: "Farrowing"}, {id: 3, label: "Moved to Farrowing"}, {id: 4, label: "Weaning"}]}, 
          {key:"animalGroupId", value:[{id: 2, label: "To"}, {id: 3, label: "Tre"}]},
        ],
   ],
    dataParameter: [
      "animalGroupId"
    ],
    startDate: 1736331492000,
    endDate: 1746703096000
  },
  {
    reportId: 31,
    name: "AC",
    dataLevel: "animalGroupId",
    filterParameter: [
        [
          {key:"milestone_id", value:[{id: 1, label: "Insemination"}, {id: 2, label: "Farrowing"}, {id: 3, label: "Moved to Farrowing"}]}, 
          {key:"animalGroupId", value:[{id: 2, label: "To"}, {id: 3, label: "Tre"}]},
        ],
   ],
    dataParameter: [
      "animalGroupId"
    ],
    startDate: 1736331492000,
    endDate: 1746703096000
  },
  {
    reportId: 23,
    name: "CB",
    dataLevel: "animalGroupId",
    filterParameter: [
        [
          {key:"milestone_id", value:[{id: 1, label: "Insemination"}, {id: 2, label: "Farrowing"}, {id: 3, label: "Moved to Farrowing"}, {id: 4, label: "Weaning"}]}, 
          {key:"animalGroupId", value:[{id: 2, label: "To"}, {id: 3, label: "Tre"}]},
        ],
   ],
    dataParameter: [
      "animalGroupId"
    ],
    startDate: 1736331492000,
    endDate: 1746703096000
  }
]

export const ReportTemplateData: ReportTemplate[] = [
  {
    templateId: 1,
    name: "B",
    dataLevel: "animal_number",
    filterParameter: [ 
        [
          {key:"milestone_id", value:[{id: 1, label: "Insemination"}, {id: 2, label: "Farrowing"}, {id: 3, label: "Weaning"}]}, 
          {key:"animalGroupId", value:[{id: 2, label: "2"}, {id: 3, label: "3"}]},
        ],
   ],
    dataParameter: [
      "animalGroupId"
    ]
  },
  {
    templateId: 3,
    name: "A",
    dataLevel: "animalGroupId",
    filterParameter: [
        [
          {key:"milestone_id", value:[{id: 1, label: "Insemination"}]}, 
          {key:"animalGroupId", value:[{id: 2, label: "2"}, {id: 3, label: "3"}]},
        ],
   ],
    dataParameter: [
      "animalGroupId"
    ]
  },
  {
    templateId: 2,
    name: "C",
    dataLevel: "animalGroupId",
    filterParameter: [
        [
          {key:"milestone_id", value:[{id: 1, label: "Insemination"}, {id: 2, label: "Farrowing"}, {id: 3, label: "Weaning"}, {id: 4, label: "Moved to Farrowing"}]}, 
          {key:"animalGroupId", value:[{id: 2, label: "2"}, {id: 3, label: "3"}]},
        ],
   ],
    dataParameter: [
      "animalGroupId"
    ]
  }
]